import {Typography} from 'components/Typography';
import {ProductReceivingMethodToday} from 'modules/product-card/components/ProductReceivingMethod/ProductReceivingMethodToday';
import {ProductReceivingMethodTomorrow} from 'modules/product-card/components/ProductReceivingMethod/ProductReceivingMethodTomorrow';
import {FC, useContext} from 'react';
import style from './style.module.scss';
import {ProductPageContext} from 'modules/product-card/context';
import {SkeletonWrapper} from 'modules/skeleton/components/SkeletonWrapper';
import {useGetWineShopListQuery} from 'modules/wineshops-list/services';
import {useProductReceivingMethods} from 'modules/product-card/hooks/useProductReceivingMethods';
import WineryWarning from 'modules/product-card/components/ProductReceivingMethod/ProductReceivingMethodWineryWarning/WineryWarning';
import {useIsPrive} from 'core/hooks/useIsPrive';
import {useWineshopList} from 'modules/wineshops-list/hooks/useWineshopList';
import {useIsWorker} from 'core/hooks/useIsWorker';
import classNames from 'classnames';
import {NEXT_PUBLIC_WINTER_DESIGN} from 'core/helpers/env';

// eslint-disable-next-line complexity
export const ProductReceivingMethod: FC = () => {
    const isPrive = useIsPrive();
    const isWorker = useIsWorker();

    const wineshopList = useWineshopList();

    const {expressWineshop: userWineshop, isExpressWineshopLoading} = useContext(ProductPageContext);

    const {isFetching: isWineshopListLoading} = useGetWineShopListQuery();

    const {showPickupToday, shopPickupTomorrow, isUserWineshopTodayWarning} = useProductReceivingMethods();

    const isLoading = isExpressWineshopLoading || isWineshopListLoading;

    if (!isLoading && (isPrive || 0 === wineshopList.length)) {
        return null;
    }

    const hasReceivingMethods = showPickupToday || shopPickupTomorrow || isLoading;

    return (
        <>
            <div
                className={classNames(style.main, {
                    // NEW_YEAR_2026
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    'pdp-buy-block-mobile-winter-design': NEXT_PUBLIC_WINTER_DESIGN,
                })}
            >
                <SkeletonWrapper disabled={!isLoading} className={style.wrapper}>
                    {hasReceivingMethods && (
                        <Typography className={style.title} variant={'label-16-m'} data-skeleton-item={true}>
                            Способы получения заказа:
                        </Typography>
                    )}
                    {(showPickupToday || isLoading) && !isWorker && <ProductReceivingMethodToday />}
                    {(shopPickupTomorrow || isLoading) && <ProductReceivingMethodTomorrow />}
                </SkeletonWrapper>
            </div>
            {userWineshop && isUserWineshopTodayWarning && (
                <div className={'d-block-only-sm'}>
                    <WineryWarning titleVinoteki={userWineshop.titleVinoteki} />
                </div>
            )}
        </>
    );
};
